import SaleFilters from './SaleFilters';

export default SaleFilters;